import { JWTRole } from "@hackthenorth/north";

/**
 * Judging is organizer + hacker only. Organizers keep access for QA while
 * the section is closed; hackers need `eventMeta.judging.isOpen`. Other
 * roles (sponsor, general, volunteer, …) are denied here. Independent of the
 * shared hacker post-RSVP tools gate.
 */
export const canAccessJudging = (
  roles: JWTRole[],
  isOrganizer: boolean,
  judgingOpen: boolean
): boolean => isOrganizer || (roles.includes(JWTRole.HACKER) && judgingOpen);
